import { doc, getDoc, setDoc } from 'firebase/firestore';
import { db } from '../lib/firebase';
import { GLOBAL_SETTINGS, bumpSettingsVersion, type GlobalSettings } from '../data/settings';

const SETTINGS_ID = 'global_settings_v1';

export const fetchGlobalSettings = async (): Promise<GlobalSettings | null> => {
  // A failed Firestore read (e.g. no backend configured in a bare dev run)
  // returns null via the catch below, so boot proceeds on the static defaults
  // in `src/data/settings.ts`.
  try {
    const configRef = doc(db, 'system_config', SETTINGS_ID);
    const snap = await getDoc(configRef);
    if (snap.exists()) {
      const data = snap.data() as GlobalSettings;
      Object.assign(GLOBAL_SETTINGS, data);
      bumpSettingsVersion();
      return data;
    }
    // Seed DB with defaults.
    await setDoc(configRef, GLOBAL_SETTINGS);
    return null;
  } catch (error) {
    console.error('Failed to fetch global settings from Firestore', error);
    return null;
  }
};

export const deployGlobalSettings = async (settings: GlobalSettings): Promise<void> => {
  const configRef = doc(db, 'system_config', SETTINGS_ID);
  await setDoc(configRef, settings);
  Object.assign(GLOBAL_SETTINGS, settings);
  bumpSettingsVersion();
};
